import { createReducer } from './index';
import { fromJS } from 'immutable';
import * as ActionTypes from '../actions/types';
import _ from 'lodash';

const validatePillarsWeights = (pillars) => {
  const errors = [];
  const reducedWeightOld = _.reduce(pillars, (sum, current) => { return sum + current.weightOld }, 0);
  const reducedWeightNewComing = _.reduce(pillars, (sum, current) => { return sum + current.weightNewComing }, 0);
  const reducedWeightNew = _.reduce(pillars, (sum, current) => { return sum + current.weightNew }, 0);
  if(reducedWeightOld !== 100 && reducedWeightOld) {
    errors.push(`Η εξάμηνη βαρύτητα δεν αθροίζεται στο 100 (Σύνολο: ${reducedWeightOld})`)
  }
  if(reducedWeightNewComing !== 100 && reducedWeightNewComing) {
    errors.push(`Η βαρύτητα των υφιστάμενων καταστημάτων δεν αθροίζεται στο 100. (Σύνολο: ${reducedWeightNewComing})`)
  }
  if(reducedWeightNew !== 100 && reducedWeightNew) {
    errors.push(`Η βαρύτητα των νέων καταστημάτων δεν αθροίζεται στο 100. (Σύνολο: ${reducedWeightNew})`)
  }
  return errors;
};

const INITIAL_STATE = fromJS({
  pillars: fromJS([]),
  fetching: false,
  errors: fromJS([])
});

function getPillars(state, action) {
  return state
    .set('fetching', true)
}

function getPillarsSuccess(state, action) {
  const errors = validatePillarsWeights(action.payload.body);
  return state
    .set('fetching', false)
    .set('pillars', fromJS(action.payload.body))
    .set('errors', fromJS(errors))
}

function getPillarsFailed(state, action) {
  return state
    .set('fetching', false)
}

function changePillarsState(state, action) {
  return state
    .set(action.payload.key, fromJS(action.payload.value))
}

export const pillars = createReducer(INITIAL_STATE, {
  [ActionTypes.GET_PILLARS]: getPillars,
  [ActionTypes.GET_PILLARS_SUCCESS]: getPillarsSuccess,
  [ActionTypes.GET_PILLARS_FAILED]: getPillarsFailed,
  [ActionTypes.CHANGE_PILLARS_STATE]: changePillarsState,
});



// WEBPACK FOOTER //
// ./src/reducers/pillars.js